<template>
  <v-container ma-0 pa-0 fluid full-width v-resize="resize">

    <v-data-table ref="table" v-model="syncProps.selectedItems" v-bind="InnerProps"
      class="elevation-1 fixed-header v-table__overflow" :style="{maxHeight: maxHeight,backfaceVisibility:
      'hidden'}" :pagination.sync="syncProps.pagination" :rows-per-page-items="[10,20,50,100,500]" select-all>
      <template #items="props">
        <vuetify-row :props="props" :headers="Headers">
          <template v-slot:[getTemplateName(item)]="{props}" v-for="item in Headers">
            <slot :name="'table-cell-'+item.value" :props="props.props">
            </slot>
          </template>
        </vuetify-row>
      </template>
      <template slot="no-data">
        <v-alert :value="true" color="error" icon="warning">
          抱歉, 没有找到所需数据 :(
        </v-alert>
      </template>
    </v-data-table>
  </v-container>
</template>



<script>
  import VuetifyTable from "./vuetifyTable.ts";
  export default VuetifyTable;
</script>